export default __webpack_public_path__ + "static/media/hefner-monogram.bb13cd5b.svg";